export default {
  registrationsNotAllowedDialog: {
    title: 'Registration Not Allowed',
    message: 'Regsitrations are not a',
    closeButton: 'Close',
  }
}
